import {ThemeIconKey} from 'platform/foundation';

import {CustomNoticeIcon} from '@dms/api/core';

export const CUSTOM_NOTICE_ICONS: Record<CustomNoticeIcon, ThemeIconKey> = {
  information: 'action/info',
  warning: 'alert/warning',
  danger: 'alert/error',
  help: 'action/help',
  checkmark: 'action/check_circle',
  remove: 'content/remove_circle',
  notification: 'social/notifications',
  person: 'social/person',
  vehicle: 'maps/directions_car',
};
